// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"704":"3d38b6e5","784":"7f7e05b1"}[chunkId] + ".chunk.css";
};